import { render, staticRenderFns } from "./jiediaoshenhe.vue?vue&type=template&id=02971e50&scoped=true"
import script from "./jiediaoshenhe.vue?vue&type=script&lang=js"
export * from "./jiediaoshenhe.vue?vue&type=script&lang=js"
import style0 from "./jiediaoshenhe.vue?vue&type=style&index=0&id=02971e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02971e50",
  null
  
)

export default component.exports